export default function paymentsErrorHandler(code: string) {
  switch (code) {
    case "PBPAYCreatePaymentFailed":
      return "errors.PBPAYCreatePaymentFailed"
    default:
      return ""
  }
}
